module.exports = __webpack_public_path__ + "static/media/project_empty_circle3@2x.c56610dd.png";